import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import Login from "../../../pages/Admin/login/login";

function UploadBlogImage() {
  const [blogImage, setBlogImage] = useState(null);
  const [images, setImages] = useState(null);
  const[isAuthenticated,setIsAuthenticated]=useState(false)
  const ImageAPI = process.env.REACT_APP_IMAGE_URL;

  useEffect(()=>{
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if(storedToken){
      getAllImages();
      setIsAuthenticated(true)
    }
  },[])
  const baseAPI = process.env.REACT_APP_API_URL;

  const getAllImages = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(`${baseAPI}/CMB/GETBlogsInnerImages`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        console.log(response.data.data);
        setImages(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  };

  function isValidFileType(file) {
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/svg"];
    return file && allowedTypes.includes(file.type);
  }

  function handleChangeDoc(e) {
    const { name, value, files } = e.target;
    const file = files[0];
    if (isValidFileType(file)) {
      setBlogImage({ ImagePath: files[0] });
    } else {
      alert("Unsupported file type. Please upload a valid file.");
      e.target.value = null;
      return;
    }
  }

  const getCurrentImage = (image) => {
    return `${ImageAPI}Images/Blogs/${image}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const storedToken = JSON.parse(localStorage.getItem("token"));
    const data = new FormData();
    data.append("ImagePath", blogImage.ImagePath);
    try {
      const response = await axios.post(
        `${baseAPI}/CMB/AddBlogInnerImage`,
        data,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      alert(`Image Added Successfully`);
      getAllImages();
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };
if(isAuthenticated){
  return (
    <div className="px-4">
      <h3 className="py-4 text-center">Add Blog Inner Image</h3>
      <form>
        <div class="mb-3 d-flex">
          <input
            onChange={handleChangeDoc}
            class="form-control m-1"
            type="file"
            id="formFile"
          />
          <button
            onClick={handleSubmit}
            type="submit"
            class="btn btn-primary m-1"
          >
            Submit
          </button>
        </div>
      </form>
      <table class="table" style={{ border: "2px solid rgb(235 231 231)" }}>
        <thead>
          <tr>
            <th
              className="text-center"
              style={{ border: "2px solid rgb(235 231 231)" }}
              scope="col"
            >
              S. No.
            </th>
            <th
              className="text-center"
              style={{ border: "2px solid rgb(235 231 231)" }}
              scope="col"
            >
              ImagePath
            </th>
            <th
              className="text-center"
              style={{ border: "2px solid rgb(235 231 231)" }}
              scope="col"
            >
              Image
            </th>
          </tr>
        </thead>
        <tbody>
          {images && images.length > 0
            ? images.map((image, idx) => (
                <tr key={idx}>
                  <th
                    className="text-center"
                    style={{ border: "2px solid rgb(235 231 231)" }}
                    scope="row"
                  >
                    {idx + 1}
                  </th>
                  <td
                    className="text-center"
                    style={{ border: "2px solid rgb(235 231 231)" }}
                  >{`${ImageAPI}/Images/Blogs/${image.ImagePath}`}</td>
                  <td
                    className="text-center"
                    style={{ border: "2px solid rgb(235 231 231)" }}
                  >
                    <img
                      style={{ objectFit: "contain", height: "200px" }}
                      src={getCurrentImage(image.ImagePath)}
                    />
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </table>
    </div>
  );
}
else{
  return <Login/>
}

}

export default UploadBlogImage;
